let browserWidth;


// Get the number of items to show based on screen size or layout type
const getNumItemsToShow = (grid, numItemsToShowOverride) => {
    const gridLayout = grid.getAttribute('data-grid-layout');
    const gridLayoutMobile = grid.getAttribute('data-grid-mobile-layout');
    browserWidth = document.body.clientWidth;
    let layout;

    if (browserWidth >= 768) {
        // Large
        layout = gridLayout || 'grid3';
    } else {
        // Small
        layout = gridLayoutMobile || 'grid3';

    }

    let numItemsToShow;

    switch (layout) {
        case 'grid5':
        case 'mobile-grid5':
            numItemsToShow = 10;
            break;
        case 'grid4':
        case 'mobile-grid4':
            numItemsToShow = 8;
            break;
        case 'grid3':
            numItemsToShow = 9;
            break;
        case 'mobile-grid3':
            numItemsToShow = 6;
            break;
        case 'grid2':
        case 'mobile-grid2':
            numItemsToShow = 4;
            break;
        case 'grid1':
        case 'mobile-grid1':
            numItemsToShow = 2;
            break;
        default:
            numItemsToShow = 10;
    }

    // Override Number of items
    if (numItemsToShowOverride) {
        numItemsToShow = numItemsToShowOverride;
    }

    return numItemsToShow;
};


// OnClick Show grid items
const onClickShowMoreItems = (hiddenGridItems, numItemsToShow) => {
    let i = 0;
    for (const gridItem of hiddenGridItems) {
        if (i < numItemsToShow) {
            gridItem.style.opacity = 0;
            gridItem.style.visibility = 'visible';
            gridItem.style.transitionDelay = '.2s';
            gridItem.classList.remove('hide');
            setTimeout(function () {
                gridItem.style.opacity = 1;
            }, 100);
        }
        i++;
    }
};


// Init this grid
const onGridInit = (grid) => {

    const numItemsToShowOverride = grid.getAttribute('data-number-items-to-show-override');
    const showMoreButton = grid.querySelector('.grid-show-more-button');
    const gridItems = grid.querySelectorAll('.grid-item');
    let numItemsToShow = getNumItemsToShow(grid, numItemsToShowOverride);

    // Hide grid items
    let hasMoreItemsToShow = false;
    let i = 1;
    for (const gridItem of gridItems) {
        if (i > numItemsToShow) {
            hasMoreItemsToShow = true;
            gridItem.classList.add('hide');
        } else {
            gridItem.style.visibility = 'visible';
        }
        i++;
    }

    // Show button if there are more items to show
    if (hasMoreItemsToShow && showMoreButton) {

        showMoreButton.style.visibility = 'visible';
        showMoreButton.style.opacity = 1;

        // CLICK Show More
        showMoreButton.addEventListener('click', function () {
            const hiddenGridItems = grid.querySelectorAll('.grid-item.hide');
            numItemsToShow = getNumItemsToShow(grid, numItemsToShowOverride);
            onClickShowMoreItems(hiddenGridItems, numItemsToShow);

            // Hide button if all grid items are visible
            if (hiddenGridItems.length <= numItemsToShow) {
                showMoreButton.style.display = 'none';
            }
        });

    } else if (!hasMoreItemsToShow && showMoreButton) {

        showMoreButton.style.display = 'none';

    }

};


// Init all grids
const onGridsInit = () => {
    const grids = document.querySelectorAll('.caption .grid');

    for (const grid of grids) {
        onGridInit(grid);
    }

};


export {
    onGridsInit
};
